// Alert preference used in user edit alert preference page
export const AlertPreferece =[
    {"value": 0, "label" : "device_update_email"},
    {"value": 0, "label" : "device_update_sms"},
    {"value": 0, "label" : "workorder_update_email"},
    {"value": 0, "label" : "workorder_update_sms"},
    {"value": 0, "label" : "monthly_report_email"},
    {"value": 0, "label" : "monthly_report_sms"},
  ];
